import React, { useCallback, useEffect, useState } from 'react';

import { pausedInvoiceIcon } from '@europrocurement/l2d-icons';
import { useNavigate } from 'react-router';
import {
    factureAchatsFiltersToElasticQuery,
    useAchatsService,
    useSociete,
} from '@europrocurement/l2d-domain';
import { WidgetWithAction } from '@europrocurement/l2d-modules';
import achatsViewPathResolver from '../../../../Achats/achatsViewPathResolver';

// All

const FacturesEnPause: React.FunctionComponent = function () {
    const navigate = useNavigate();
    const xIdSociete = useSociete();

    const { factureAchatApi } = useAchatsService();

    const [countOfInvoicesResumed, setCountOfInvoicesResumed] = useState<string>();

    const fetchCount = useCallback(() => {
        factureAchatApi
            .getFacturesAchatsFactureAchatCollection(
                factureAchatsFiltersToElasticQuery({
                    xIdSociete,
                    search: '',
                    orders: [],
                    pagination: {
                        page: 0,
                        itemsPerPage: 0,
                    },
                    filters: {
                        cloture: false,
                        deleted: false,
                    },
                }),
            )
            .then((res) => {
                if (
                    res.data['hydra:totalItems'] !== null ||
                    res.data['hydra:totalItems'] !== undefined
                ) {
                    setCountOfInvoicesResumed(`${res.data['hydra:totalItems']}`);
                }
            });
    }, [factureAchatApi, xIdSociete]);

    useEffect(() => {
        fetchCount();
    }, [fetchCount]);

    const actionCallback = useCallback(async () => {
        navigate(achatsViewPathResolver('listfacturepause'));
    }, [navigate]);

    return (
        <WidgetWithAction
            title="Factures en pause"
            icon={pausedInvoiceIcon}
            actionMessage="Traiter"
            actionCallback={actionCallback}
            data={countOfInvoicesResumed}
            color="warning"
            onRetryData={fetchCount}
        />
    );
};

export default FacturesEnPause;
